export default class MenuItemType {
  static get Bundle () {
    return 'bundle'
  }

  static get Single () {
    return 'single'
  }
}
